import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedComponents } from '../../shared.module';

@Component({
  selector: 'app-logs-modal',
  standalone: true,
  imports: [CommonModule, SharedComponents],
  templateUrl: './logs-modal.component.html',
  styleUrl: './logs-modal.component.scss'
})
export class LogsModalComponent {

  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;

  @Input()
  configs: any = {};

  logOutput:string= "";

}
